import { useQuery } from "@tanstack/react-query";
import { getClients } from "api/client.api";
import { gracefulList } from "lib/queryHelpers";
import { DEFAULT_STALE_TIME } from "config/constants";

const normalizeClients = (data) => {
  const clients = data?.clients || data?.data?.clients || data?.data || [];

  if (!Array.isArray(clients)) return [];

  return clients.map((client) => ({
    ...client,
    id: client.id || client._id,
    name:
      client.name ||
      client.clientName ||
      client.businessName ||
      "Unnamed Client",
  }));
};

export const useGetRefundClients = () => {
  return useQuery({
    queryKey: ["refunds", "clients"],
    queryFn: gracefulList(getClients, { clients: [] }),
    select: normalizeClients,
    staleTime: DEFAULT_STALE_TIME,
  });
};
